var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('justifi-payment-provisioning',{attrs:{"business-id":_vm.justifiBusinessId,"auth-token":_vm.webComponentToken,"form-title":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }